var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8156_4509)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.26422 2.01997C9.50016 1.78401 9.81601 1.64509 10.1494 1.63064C10.4828 1.6162 10.8094 1.72729 11.0649 1.94197L11.1496 2.01997L13.9782 4.84864C14.214 5.08454 14.3528 5.40025 14.3672 5.73347C14.3817 6.06669 14.2707 6.39322 14.0562 6.64864L13.9782 6.73397L7.10222 13.61C6.88088 13.8313 6.58871 13.9677 6.27689 13.9953L6.15956 14H2.67089C2.32423 14 2.03823 13.7373 2.00156 13.4L1.99756 13.3266V9.83797C1.99764 9.52494 2.10785 9.22191 2.30889 8.98197L2.38889 8.8953L9.26422 2.01997ZM8.11356 5.05597L3.33089 9.83864V12.6666H6.16022L10.9429 7.88397L8.11422 5.0553L8.11356 5.05597ZM10.2069 2.96264L9.05622 4.1133L11.8849 6.94197L13.0356 5.7913L10.2069 2.96264Z",
    fill: "#09244B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8156_4509"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.9e48a3cf1f0b4f242d964caecd123e9e.svg";
export { ForwardRef as ReactComponent };